export const CREATOR_TIER_SET_CREATE = `mutation CreatorTierSetCreate($input: CreatorTierSetCreateMutationInput!) {
    creatorTierSetCreate(input: $input) {
        creatorTiers {
            id
            name
            minSalesAmount
            maxSalesAmount
            minFollowers
            maxFollowers
        }
    }
}`;
